module.exports = __webpack_public_path__ + "img/abmes-01-v2.9fdf877f.png";